export const SIGN_IN_ELEMENT_ID = 'sign-in-header'
